module.exports = __webpack_public_path__ + "img/g-point.d72afc22.png";